import React, { useState, useRef } from "react";
import axios from "axios";
import VinosList from "./VinosList";
import "./AdminPanel.css";

function AdminPanel() {
  const [nuevoVino, setNuevoVino] = useState({ nombre: "", año: "", uva: "" });
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
  const [mensaje, setMensaje] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const vinosListRef = useRef(null); // Referencia para actualizar VinosList

  const handleBuscarVinoAI = () => {
    if (!nuevoVino.nombre) {
      setMensaje("Por favor, introduce el nombre del vino para buscar información.");
      return;
    }

    axios
      .post("http://localhost:5000/buscar-vino", {
        nombre: nuevoVino.nombre,
        año: nuevoVino.año || "",
        uva: nuevoVino.uva || "",
      })
      .then((response) => {
        const detalles = response.data.detalles;
        if (detalles && detalles.length > 0) {
          setResultadosBusqueda(detalles);
          setMostrarModal(true);
        } else {
          setMensaje("No se encontraron resultados para el vino.");
        }
      })
      .catch((error) => {
        console.error("Error al buscar información del vino:", error);
        setMensaje("Error al buscar información del vino.");
      });
  };

  const agregarVino = (vino) => {
    axios
      .post("http://localhost:5000/vinos", {
        nombre: vino.nombre,
        region: vino.region || "Desconocida",
        variedad_uva: vino.uva || "Desconocida",
        precio: vino.precio || 45.5,
        tipo: vino.tipo || "Desconocido",
        descripcion: vino.descripcion || "",
        etiqueta_url: vino.etiqueta_url || "https://via.placeholder.com/300",
      })
      .then(() => {
        setMensaje("Vino agregado exitosamente.");
        setMostrarModal(false);
        setResultadosBusqueda([]);
        // Actualiza la lista de vinos
        if (vinosListRef.current) vinosListRef.current.fetchVinos();
      })
      .catch((error) => {
        console.error("Error al agregar el vino:", error);
        setMensaje("Error al agregar el vino.");
      });
  };

  return (
    <div>
      <h1>Panel de Administración</h1>
      {mensaje && <p className="mensaje">{mensaje}</p>}

      {/* Buscar Información de Vinos */}
      <div className="busqueda">
        <h2>Buscar Información de Vino</h2>
        <input
          type="text"
          placeholder="Nombre del vino"
          value={nuevoVino.nombre}
          onChange={(e) => setNuevoVino({ ...nuevoVino, nombre: e.target.value })}
        />
        <input
          type="text"
          placeholder="Año del vino (opcional)"
          value={nuevoVino.año}
          onChange={(e) => setNuevoVino({ ...nuevoVino, año: e.target.value })}
        />
        <input
          type="text"
          placeholder="Variedad de uva (opcional)"
          value={nuevoVino.uva}
          onChange={(e) => setNuevoVino({ ...nuevoVino, uva: e.target.value })}
        />
        <button onClick={handleBuscarVinoAI}>Buscar Información</button>
      </div>

      {/* Modal para Resultados de Búsqueda */}
      {mostrarModal && (
        <div className="modal">
          <div className="modal-content">
            <h3>Resultados de la búsqueda</h3>
            {resultadosBusqueda.map((vino, index) => (
              <div key={index} className="modal-item">
                <p>
                  <strong>Nombre:</strong> {vino.nombre}
                </p>
                <p>
                  <strong>Región:</strong> {vino.region}
                </p>
                <p>
                  <strong>Variedad de Uva:</strong> {vino.variedad_uva}
                </p>
                <button onClick={() => agregarVino(vino)}>Agregar Vino</button>
              </div>
            ))}
            <button onClick={() => setMostrarModal(false)}>Cerrar</button>
          </div>
        </div>
      )}

      {/* Componente VinosList */}
      <VinosList ref={vinosListRef} />
    </div>
  );
}

export default AdminPanel;
